import React, { useState, useCallback, useEffect } from 'react'
import "./../../App.css";
import { 
  CreateTable, 
  Button, 
  SearchBar,
  OnBoardingPersonnelSelectForm,
  OnBoardingRequirementsSelect,
  FailMessage 
} from './../../common/APICommon';
import {token, domain} from '../Security';
import axios from 'axios';
import AddIcon from '@mui/icons-material/Add';
import EditIcon from '@mui/icons-material/Edit';
import VisibilityIcon from '@mui/icons-material/Visibility';
import PersonSearchIcon from '@mui/icons-material/PersonSearch';
import CancelPresentationIcon from '@mui/icons-material/CancelPresentation';
import ErrorIcon from '@mui/icons-material/Error';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import DownloadIcon from '@mui/icons-material/Download';
import loadingSpinner from './../../assets/loading.gif';
import SyncIcon from '@mui/icons-material/Sync';

function OnBoarding({user, userAccess, isHideSideMenu}) {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const [selectedData, setSelectedData] = useState(null);

  const [employee, setEmployee] = useState(null);
  const [onBoardingRequirements, setOnBoardingRequirements] = useState(null);
  const [file, setFile] = useState(null);
  const [hasCompleted, setHasCompleted] = useState(false);
  const [isActive, setIsActive] = useState(false);

  const resetLocalVariables = () => {
    setSelectedData(null);
    setEmployee(null);
    setOnBoardingRequirements(null);
    setFile(null);
    setHasCompleted(false);
    setIsActive(false);
  }

  const fetchData = useCallback(async () => {
    const apiUrl = domain + "/api/OnBoarding";
    try {
        setLoading(true);
        const response = await axios.get(apiUrl , {
        headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json' // You can include other headers if needed
    }})
        setData(response.data); // Set the response data to the state
        setFilteredData(response.data); // Set the response data to the state
    } catch (error) {
        console.error('Error fetching data:', error);
    } finally {
        setLoading(false); // Set loading state to false after data fetching is complete
    }
  }, []);

  useEffect(() => {
    fetchData()
  }, [fetchData])

  //Request Messages -start
  const [showRequestMessage, setShowRequestMessage] = useState(false);
  const [requestMessage, setRequestMessage] = useState("");
  const [isSuccess, setIsSuccess] = useState("");
  useEffect(() => {
      if (showRequestMessage) {
          const timeoutId = setTimeout(() => {
              setShowRequestMessage(false);
          }, 5000);

          return () => clearTimeout(timeoutId);
      }
      
  }, [showRequestMessage]);
  function GenerateMessage({form, message, isSuccess}){
      return (
          <>
              <div className={`modal-overlay toggleMessage-overlay ${form ? 'open' : ''}`}>
                  {form && (
                  <div className="modal toggleMessage" style={{backgroundColor: isSuccess ? "#E0FFDC" : "#ffd0c5"}}>
                      <div className='column'>
                          {isSuccess ?
                              <div className='request_title row' style={{fontWeight:"bold", color:"green", alignItems:"center"}}>
                                  <CheckCircleIcon/>
                                  <span >{"SUCCESS MESSAGE"}</span>
                              </div>
                              :
                              <div className='request_title row' style={{fontWeight:"bold", color:"#DD5746", alignItems:"center"}}>
                                  <ErrorIcon/>
                                  <span>{"ERROR MESSAGE"}</span>
                              </div>
                          }
                          <span style={{textAlign:"center", padding:"10px 0", color: isSuccess? "green" : "#DD5746"}}>{message}</span>
                      </div>
                  </div>
              )}
              </div>
          </>
      );
  }
  //Request Messages -end

  const [showAddForm, setShowAddForm] = useState(false);
  const openAddForm = () => {
    setShowAddForm(true);
  }
  const closeAddForm = () => {
    setShowAddForm(false);
    resetLocalVariables();
  }
  const fileToBase64 = (file) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result.split(",")[1]); // get Base64 without prefix
    reader.onerror = (error) => reject(error);
  });
};
  const handleAddClick = async () => {
    const apiUrl = domain + "/api/OnBoarding/requirement";
    const base64File = file ? await fileToBase64(file) : null;

    const data = {
      onBoardingId: selectedData.id,
      onBoardingRequirementsId: onBoardingRequirements.id,
      file: base64File, // backend must decode this into byte[]
      hasCompleted: hasCompleted,
      isActive: isActive,
    };

    try {
        setLoading(true);
        await axios.post(apiUrl, data, {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json'
            }
        });
        
        await fetchData(); // Assuming fetchData() fetches the updated data for the table

        console.log('Data added successfully');
        setShowRequestMessage(true);
        setIsSuccess(true);
    } catch (error) {
        console.error('There was a problem adding data:', error);
        setShowRequestMessage(true);
        setIsSuccess(false);
        const errorMessage = JSON.parse(error.response.request.responseText).message;
        setRequestMessage(errorMessage);
    } finally {
        setLoading(false);
    }
  };

  const [showViewForm, setShowViewForm] = useState(false);
  const openViewForm = () => {
    setShowViewForm(true);
  }
  const closeViewForm = () => {
    setShowViewForm(false);
    resetLocalVariables();
  }

  
  // search
  const [filteredData, setFilteredData] = useState([]);
  const handleFilter = (value) => {
    setCurrentPage(1);

    const lowercaseValue = value.toLowerCase();

    const res = filteredData.filter((f) => {
      console.log(f)
      return (
        f?.outBoardingPersonnelFullName?.toLowerCase()?.includes(lowercaseValue) ||
        f?.outBoardingPersonnelEmployeeId?.toString()?.toLowerCase()?.startsWith(lowercaseValue)
      )});

    setData(res);
  };

  const [showAddPersonnelForm, setShowAddPersonnelForm] = useState(false);
  const openAddPersonnelForm = () => {
    setShowAddPersonnelForm(true);
  }
  const closeAddPersonnelForm = () => {
    setShowAddPersonnelForm(false);
  }
  const handleAddPersonnelClick = async () => {
    const apiUrl = domain + "/api/OnBoarding";

    const data = {
      onBoardingPersonnelId: employee.id,
      isActive: isActive,
    };

    try {
        setLoading(true);
        await axios.post(apiUrl, data, {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json'
            }
        });
        await fetchData(); // Assuming fetchData() fetches the updated data for the table

        console.log('Data added successfully');
        setShowRequestMessage(true);
        setIsSuccess(true);
    } catch (error) {
        console.error('There was a problem adding data:', error);
        setShowRequestMessage(true);
        setIsSuccess(false);
        const errorMessage = JSON.parse(error.response.request.responseText).message;
        setRequestMessage(errorMessage);
    } finally {
        setLoading(false);
    }
  };
  

  // Table /////////////////////////////////////////////
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;

  const headers = [
    'Employee Id', 
    'Name', 
    'Is Active?', 
    'Actions'
  ]
  const accessors = [
    'onBoardingPersonnelEmployeeId', 
    'onBoardingPersonnelFullName', 
    'isActive', 
    'actions'
  ]

  const addHandleClick = (data) => {
    setSelectedData(data);
    openAddForm()
  }

  const viewHandleClick = (data) => {
    setSelectedData(data);
    openViewForm()
  }

  const [showSyncForm, setShowSyncForm] = useState(false);
  const openSyncForm = () => {
    setShowSyncForm(true);
  }
  const closeSyncForm = () => {
    setShowSyncForm(false);
  }

  const syncHandleClick = (data) => {
    setSelectedData(data);
    openSyncForm()
  }

  const fetchDataAccessTemplate =  useCallback(async () => {
    const apiUrl =  domain + "/api/AccessTemplate";

      try {
          setLoading(true);
          const response = await axios.get(apiUrl , {
              headers: {
                  'Authorization': `Bearer ${token}`,
                  'Content-Type': 'application/json' // You can include other headers if needed
          }})
          return response.data;
      } catch (error) {
        console.error('Error fetching data:', error);
        return [];
    }
  }, []);
  const fetchDataAccounts = useCallback(async () => {
    const apiUrl =  domain + "/api/Authentication/all-usernames";

    try {
        setLoading(true);
        const response = await axios.get(apiUrl , {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json' // You can include other headers if needed
        }})
        return response.data; 
    } catch (error) {
        console.error('Error fetching data:', error);
        return []
    }
  }, []);
  const fetchDataEmployeeByEmployeeId = useCallback(async (employeeId) => {
    const apiUrl =  domain + "/api/Employee";

    try {
        setLoading(true);
        const response = await axios.get(apiUrl + `/employeeId/${employeeId}`, {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json' // You can include other headers if needed
        }})
        return response.data; 
    } catch (error) {
        console.error('Error fetching data:', error);
        return null
    }
  }, []);

  const createAccount = async (employee) => {
    const accessTemplate = await fetchDataAccessTemplate();
    const employeeInfo = await fetchDataEmployeeByEmployeeId(employee.employeeId);
    const accounts = await fetchDataAccounts();

    const foundTemplate = accessTemplate.find(data => 
        data.description.toLowerCase() === ("Employee").toLowerCase()
    );
    /* const foundEmployee = employeeInfo.find(data => 
      data.employeeId.toLowerCase().trim() === employee.employeeId.toLowerCase().trim()
    ); */

    function generateUniqueUsernames(employee, existingUsernames) {
      const firstNameInitial = employee.firstName.charAt(0).toLowerCase();
      const lastNameLower = employee.lastName.replace(/\s+/g, '').toLowerCase(); // Remove spaces from last name
      let baseUsername = firstNameInitial + lastNameLower;
  
      let uniqueUsername = baseUsername;
      let counter = 1;
  
      while (existingUsernames.includes(uniqueUsername)) {
          uniqueUsername = `${baseUsername}${counter}`;
          counter += 1;
      }
  
      existingUsernames.push(uniqueUsername); // Add the new username to the list to avoid duplicates
      return uniqueUsername;
    }

    console.log(employee)
    
    const apiUrl =  domain + "/api/Authentication";

    const existingUsernames = [];

    accounts.forEach(employee => {
        existingUsernames.push(employee.username);
    });

    const username = generateUniqueUsernames(employee, existingUsernames);
    existingUsernames.push(username);

    const data = {
        username: username,
        password: "password",
        employeePersonalInformationId: employeeInfo.id,
        accessTemplateId: foundTemplate.id
    };

    try {
        axios.post(apiUrl + `/register`, data, {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json'
            }
        });
        
    } catch (error) {
        setShowRequestMessage(true);
        setIsSuccess(false);
        console.error('Error:', error);
        const errorMessage = JSON.parse(error.response.request.responseText).message;
        setRequestMessage(errorMessage);
    }
  }

  const handleSyncUser = async () => {
    const apiUrl = domain + "/api/OnBoarding/sync-user";

    const data = {
      employeeId: selectedData?.onBoardingPersonnelEmployeeId,
      lastName: selectedData?.onBoardingPersonnelLastName,
      firstName: selectedData?.onBoardingPersonnelFirstName,
      middleName: selectedData?.onBoardingPersonnelMiddleName,
    };

    try {
        setLoading(true);
        const response = await axios.post(apiUrl, data, {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json'
            }
        });

        await createAccount(response.data);
        await fetchData(); // Assuming fetchData() fetches the updated data for the table

        console.log('Data added successfully');
        setShowRequestMessage(true);
        setIsSuccess(true);
    } catch (error) {
        console.error('There was a problem adding data:', error);
        setShowRequestMessage(true);
        setIsSuccess(false);
        const errorMessage = JSON.parse(error.response.request.responseText).message;
        setRequestMessage(errorMessage);
    } finally {
        setLoading(false);
    }
  }

  const actions = [
    { 
      name: "Add", 
      tooltip: "add",
      icon: <AddIcon fontSize="small" />,
      className: "bg-green-500 hover:bg-green-600 flex items-center",
      function: addHandleClick,
      visible: false,
    },
    { 
      name: "View", 
      tooltip: "view",
      icon: <VisibilityIcon fontSize="small" />,
      className: "bg-sky-500 hover:bg-sky-600 flex items-center",
      function: viewHandleClick,
      visible: true,
    },
    { 
      name: "Sync", 
      tooltip: "sync",
      icon: <SyncIcon fontSize="small" />,
      className: "bg-blue-500 hover:bg-blue-600 flex items-center",
      function: syncHandleClick,
      visible: true,
    },
  ];
  // Table /////////////////////////////////////////////

  // console.log("selectedData", selectedData)

  return (
    <>
      <div className={`MainBody row ${isHideSideMenu ? "MainBody2" : ""}`}>
        <div className="LeftSpace"></div>
        <div className={`BodySpace ${isHideSideMenu ? "BodySpace2" : ""}`}>
          <div className="EmployeesTabInfo shadow-xl">
            <div className="employeesTab-header">
                <div className='sub-title row'>
                    <span style={{padding:"0 5px 0 0", color:"#b0b0b0"}}>{"Personnel >"} </span>
                    <span style={{borderBottom:"1px solid black"}}>{"On Boarding"}</span>
                </div>
                <div className='row' style={{justifyContent: "space-between", alignItems: "center"}}>
                    <h3>On Boarding</h3>
                </div>
            </div>

            <div className='p-4 space-y-4'>
              <SearchBar handleFilter={handleFilter}/>

              <Button icon={<AddIcon/>} 
                name={"Add"}
                className={"bg-customGreen hover:bg-customGreenHover border-none cursor-pointer"}
                onClick={openAddPersonnelForm}
              />

              <CreateTable
                tableName={"OnBoarding"}
                headers={headers}
                accessors={accessors}
                data={data}
                actions={actions}

                currentPage={currentPage}
                setCurrentPage={setCurrentPage}
                itemsPerPage={itemsPerPage}
                totalItems={data?.length}
              />
            </div>
          </div>
        </div>
      </div>

      <AddUpdateModal 
        visible={showAddForm}
        onClose={closeAddForm}
        onSave={handleAddClick}
        modalName={"Add Data"}

        data={data}
        employee={employee} setEmployee={setEmployee}
        onBoardingRequirements={onBoardingRequirements} setOnBoardingRequirements={setOnBoardingRequirements}
        file={file} setFile={setFile}
        hasCompleted={hasCompleted} setHasCompleted={setHasCompleted}
        isActive={isActive} setIsActive={setIsActive}
      />

      <AddPersonnelModal 
        visible={showAddPersonnelForm}
        onClose={closeAddPersonnelForm}
        onSave={handleAddPersonnelClick}
        modalName={"Add Personnel"}

        data={data}
        employee={employee} setEmployee={setEmployee}
        isActive={isActive} setIsActive={setIsActive}
      />

      { showViewForm && <DetailsModal 
        visible={showViewForm}
        onClose={closeViewForm}
        modalName={`${selectedData?.onBoardingPersonnelFullName}'s Requirements`}

        data={data}
        selectedData={selectedData}
      />}

      { showSyncForm && <SyncUserModal 
        visible={showSyncForm}
        onClose={closeSyncForm}
        modalName={`Sync User`}
        onSave={handleSyncUser}

        data={data}
        selectedData={selectedData}
      />}

      <GenerateMessage form={showRequestMessage}
              message={isSuccess ? "Request Success!" : requestMessage}
              isSuccess={isSuccess}
      > 
      </GenerateMessage>

      {loading ? (
        <div
            style={{
            position: "fixed",
            top: "0",
            left: "0",
            width: "100vw",
            height: "100vh",
            zIndex: "2000",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            textAlign: "center",
            backgroundColor: "#ffffff59",
            }}
        >
            <img src={loadingSpinner} alt="Loading..." />
        </div>
        ) : (
            <></>
            )
        }
    </>
  )
}

const AddPersonnelModal = ({ visible, onClose, onSave, modalName,
  data,
  employee, setEmployee,
  isActive, setIsActive,
}) => {
  const [failMessage, setFailMessage] = useState("");

  const [showEmployeeSelectForm, setShowEmployeeSelectForm] = useState(false);
  const openEmployeeSelectForm = () => {
    setShowEmployeeSelectForm(true);
  }
  const closeEmployeeSelectForm = () => {
    setShowEmployeeSelectForm(false);
  }

  if (!visible) return null;

  const handleSubmit = async () => {
    if(!employee){
      setFailMessage(`Please fill up required field/s.`);
      return;
    }

    await onSave();
    closeModal();
  };

  const resetLocalVariables = () => {
    setFailMessage("")
    setEmployee(null)
    setIsActive(false)
  }

  const closeModal = () => {
    onClose();
    resetLocalVariables();
  }

  return (
    <>
      <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center text-gray-600">
        <div className="bg-white rounded-lg shadow-lg w-full max-w-md p-6">
          <h2 className="text-2xl font-semibold mb-4">{modalName}</h2>

          <div className="space-y-5 mt-10 max-h-[500px] overflow-y-auto short:max-h-[300px] medium:h-[400px]">
            <div>
              <label className="block text-sm font-medium mb-1">
                On Boarding Personnel <span className="text-red-500">*</span>
              </label>

              <div className='flex flex-row items-center'>
                <input
                  type="text"
                  placeholder='--Select employee--'
                  className={`w-full border rounded-l-md px-3 py-2 focus:outline-none focus:ring focus:border-blue-300 text-gray-600 placeholder-gray-400`}
                  style={{border: "1px solid #d7d7d7"}}
                  value={employee ? `${employee?.employeeId} - ${employee?.fullName}` : ""}
                />
                { !employee ?
                <button className='flex items-center rounded-r-md border-none bg-sky-400 hover:bg-sky-500 text-white h-[33px] cursor-pointer'
                  onClick={openEmployeeSelectForm}
                >
                  <PersonSearchIcon />
                </button>
                :
                <button className='flex items-center rounded-r-md border-none bg-red-400 hover:bg-red-500 text-white h-[33px] cursor-pointer'
                  onClick={()=>setEmployee(null)}
                >
                  <CancelPresentationIcon />
                </button>
                }
              </div>
            </div>
            <div>
              <label className="inline-flex items-center text-sm font-medium mb-1">
                <input
                  type="checkbox"
                  checked={isActive}
                  onChange={(e) => setIsActive(e.target.checked)}
                  className="mr-2"
                />
                Is Active?
              </label>
            </div>
          </div>

          <div className="flex justify-end space-x-2 mt-6">
            <button
              className="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 transition border-none cursor-pointer"
              onClick={handleSubmit}
            >
              Save
            </button>
            <button
              className="px-4 py-2 bg-red-600 text-white rounded-md hover:bg-red-700 transition border-none cursor-pointer"
              onClick={closeModal}
            >
              Cancel
            </button>
          </div>
        </div>
      </div>

      <OnBoardingPersonnelSelectForm isOpen={showEmployeeSelectForm} 
        onClose={closeEmployeeSelectForm}
        data={employee}
        setData={setEmployee}
      />

      <FailMessage message={failMessage} onClose={() => setFailMessage("")} />
    </>
  );
};
const AddUpdateModal = ({ visible, onClose, onSave, modalName,
  data,
  employee, setEmployee,
  onBoardingRequirements, setOnBoardingRequirements,
  file, setFile,
  hasCompleted, setHasCompleted,
  isActive, setIsActive,
}) => {
  const [failMessage, setFailMessage] = useState("");

  const [showEmployeeSelectForm, setShowEmployeeSelectForm] = useState(false);
  const openEmployeeSelectForm = () => {
    setShowEmployeeSelectForm(true);
  }
  const closeEmployeeSelectForm = () => {
    setShowEmployeeSelectForm(false);
  }

  // for upload
  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (!file) return;

    setFile(file);
  };

  if (!visible) return null;

  const handleSubmit = async () => {
    if(!onBoardingRequirements){
      setFailMessage(`Please fill up required field/s.`);
      return;
    }

    await onSave();
    closeModal();
  };

  const resetLocalVariables = () => {
    setFailMessage("")
  }

  const closeModal = () => {
    onClose();
    resetLocalVariables();
  }

  return (
    <>
      <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center text-gray-600">
        <div className="bg-white rounded-lg shadow-lg w-full max-w-md p-6">
          <h2 className="text-2xl font-semibold mb-4">{modalName}</h2>

          <div className="space-y-5 mt-10 max-h-[500px] overflow-y-auto short:max-h-[300px] medium:h-[400px]">
            <div className='hidden'>
              <label className="block text-sm font-medium mb-1">
                On Boarding Personnel <span className="text-red-500">*</span>
              </label>

              <div className='flex flex-row items-center'>
                <input
                  type="text"
                  placeholder='--Select employee--'
                  className={`w-full border rounded-l-md px-3 py-2 focus:outline-none focus:ring focus:border-blue-300 text-gray-600 placeholder-gray-400`}
                  style={{border: "1px solid #d7d7d7"}}
                  value={employee ? `${employee?.employeeId} - ${employee?.fullName}` : ""}
                />
                { !employee ?
                <button className='flex items-center rounded-r-md border-none bg-sky-400 hover:bg-sky-500 text-white h-[33px] cursor-pointer'
                  onClick={openEmployeeSelectForm}
                >
                  <PersonSearchIcon />
                </button>
                :
                <button className='flex items-center rounded-r-md border-none bg-red-400 hover:bg-red-500 text-white h-[33px] cursor-pointer'
                  onClick={()=>setEmployee(null)}
                >
                  <CancelPresentationIcon />
                </button>
                }
              </div>
            </div>
            <div>
              <label className="block text-sm font-medium mb-1">
                Requirements <span className="text-red-500">*</span>
              </label>

              <div>
                <OnBoardingRequirementsSelect data={onBoardingRequirements} setData={setOnBoardingRequirements} isEditable={true} hasAll={false}/>
              </div>
            </div>
            <div>
              <label className="block text-sm font-medium mb-1">
                File
              </label>
              <div className="info-item-input">
                  <label htmlFor="file-input" className='column' style={{
                      color: "#808080b5",
                      fontSize: "14px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      cursor: "pointer" // Add cursor pointer for better user interaction
                  }}>
                      {!file && <img src={"images/upload-image.png"} alt="" style={{width: "auto", height: "200px"}}></img>}
                      {file ? file.name : "Click the placeholder to upload a logo"}
                  </label>
                  <input
                      id="file-input"
                      type="file"
                      style={{ display: "none" }}
                      onChange={handleFileChange}
                  />
              </div>
              <span style={{
                    visibility: "hidden",
                    color:"#ff6565", 
                    fontSize:"12px"}}>Please fill up this field
              </span>

              {file &&
              <>
                <div className='w-full'>
                  <button
                    className={"bg-blue-500 hover:bg-blue-600 border-none cursor-pointer p-1 px-2 text-white my-1 rounded-sm"}
                    onClick={() => {
                      const url = URL.createObjectURL(file); // create a blob URL
                      const link = document.createElement("a");
                      link.href = url;
                      link.download = file.name || "download"; // use file name if available
                      link.click();
                      URL.revokeObjectURL(url); // cleanup
                    }}
                  >
                    View File
                  </button>
                </div>
              </>}
            </div>
            <div>
              <label className="inline-flex items-center text-sm font-medium mb-1">
                <input
                  type="checkbox"
                  checked={hasCompleted}
                  onChange={(e) => setHasCompleted(e.target.checked)}
                  className="mr-2"
                />
                Has Completed?
              </label>
            </div>
            <div>
              <label className="inline-flex items-center text-sm font-medium mb-1">
                <input
                  type="checkbox"
                  checked={isActive}
                  onChange={(e) => setIsActive(e.target.checked)}
                  className="mr-2"
                />
                Is Active?
              </label>
            </div>
          </div>

          <div className="flex justify-end space-x-2 mt-6">
            <button
              className="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 transition border-none cursor-pointer"
              onClick={handleSubmit}
            >
              Save
            </button>
            <button
              className="px-4 py-2 bg-red-600 text-white rounded-md hover:bg-red-700 transition border-none cursor-pointer"
              onClick={closeModal}
            >
              Cancel
            </button>
          </div>
        </div>
      </div>

      <OnBoardingPersonnelSelectForm isOpen={showEmployeeSelectForm} 
        onClose={closeEmployeeSelectForm}
        data={employee}
        setData={setEmployee}
      />

      <FailMessage message={failMessage} onClose={() => setFailMessage("")} />
    </>
  );
};
const DetailsModal = ({ visible, onClose, onSave, modalName,
  data,
  selectedData,
}) => {
  const [failMessage, setFailMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const [selectedReq, setSelectedReq] = useState(null);

  const [requirements, setRequirements] = useState([])

  const [employee, setEmployee] = useState(null);
  const [onBoardingRequirements, setOnBoardingRequirements] = useState(null);
  const [file, setFile] = useState(null);
  const [hasCompleted, setHasCompleted] = useState(false);
  const [isActive, setIsActive] = useState(false);

  //Request Messages -start
  const [showRequestMessage, setShowRequestMessage] = useState(false);
  const [requestMessage, setRequestMessage] = useState("");
  const [isSuccess, setIsSuccess] = useState("");
  useEffect(() => {
      if (showRequestMessage) {
          const timeoutId = setTimeout(() => {
              setShowRequestMessage(false);
          }, 5000);

          return () => clearTimeout(timeoutId);
      }
      
  }, [showRequestMessage]);
  function GenerateMessage({form, message, isSuccess}){
      return (
          <>
              <div className={`modal-overlay toggleMessage-overlay ${form ? 'open' : ''}`}>
                  {form && (
                  <div className="modal toggleMessage" style={{backgroundColor: isSuccess ? "#E0FFDC" : "#ffd0c5"}}>
                      <div className='column'>
                          {isSuccess ?
                              <div className='request_title row' style={{fontWeight:"bold", color:"green", alignItems:"center"}}>
                                  <CheckCircleIcon/>
                                  <span >{"SUCCESS MESSAGE"}</span>
                              </div>
                              :
                              <div className='request_title row' style={{fontWeight:"bold", color:"#DD5746", alignItems:"center"}}>
                                  <ErrorIcon/>
                                  <span>{"ERROR MESSAGE"}</span>
                              </div>
                          }
                          <span style={{textAlign:"center", padding:"10px 0", color: isSuccess? "green" : "#DD5746"}}>{message}</span>
                      </div>
                  </div>
              )}
              </div>
          </>
      );
  }
  //Request Messages -end

  const [filteredData, setFilteredData] = useState([]);
  const handleFilter = (value) => {
    setCurrentPage(1);

    const lowercaseValue = value.toLowerCase();

    const res = filteredData.filter((f) => {
      return (
        f?.onBoardingRequirementsDescription?.toLowerCase()?.includes(lowercaseValue)
      )});

    setRequirements(res);
  };

  const fetchData = useCallback(async () => {
    const apiUrl = domain + `/api/OnBoarding/requirement/${selectedData?.id}`;
    try {
        setLoading(true);
        const response = await axios.get(apiUrl , {
        headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json' // You can include other headers if needed
    }})
        setRequirements(response.data?.requirements ?? []); // Set the response data to the state
        setFilteredData(response.data?.requirements ?? []); // Set the response data to the state
    } catch (error) {
        console.error('Error fetching data:', error);
    } finally {
        setLoading(false); // Set loading state to false after data fetching is complete
    }
  }, [selectedData]);

  useState(() => {
    if(visible){
      fetchData();
    }
  }, [visible, fetchData])

  // Table /////////////////////////////////////////////
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;

  const headers = [
    'Requirement', 
    'File', 
    'Has Completed?', 
    'Is Active?', 
    'Actions'
  ]
  const accessors = [
    'onBoardingRequirementsDescription', 
    'file', 
    'hasCompleted', 
    'isActive', 
    'actions'
  ]

  const [showAddForm, setShowAddForm] = useState(false);
  const openAddForm = () => {
    setShowAddForm(true);
  }
  const closeAddForm = () => {
    setShowAddForm(false);
    resetLocalVariables();
  }
  const fileToBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result.split(",")[1]); // get Base64 without prefix
      reader.onerror = (error) => reject(error);
    });
  };
  const handleAddClick = async () => {
    const apiUrl = domain + "/api/OnBoarding/requirement";
    const base64File = file ? await fileToBase64(file) : null;

    const data = {
      onBoardingId: selectedData.id,
      onBoardingRequirementsId: onBoardingRequirements.id,
      file: base64File, // backend must decode this into byte[]
      fileName: file?.name ?? null,
      hasCompleted: hasCompleted,
      isActive: isActive,
    };

    try {
        setLoading(true);
        await axios.post(apiUrl, data, {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json'
            }
        });
        
        await fetchData(); // Assuming fetchData() fetches the updated data for the table

        console.log('Data added successfully');
        setShowRequestMessage(true);
        setIsSuccess(true);
    } catch (error) {
        console.error('There was a problem adding data:', error);
        setShowRequestMessage(true);
        setIsSuccess(false);
        const errorMessage = JSON.parse(error.response.request.responseText).message;
        setRequestMessage(errorMessage);
    } finally {
        setLoading(false);
    }
  };

  const [showUpdateForm, setShowUpdateForm] = useState(false);
  const openUpdateForm = () => {
    setShowUpdateForm(true);
  }
  const closeUpdateForm = () => {
    setShowUpdateForm(false);
    resetLocalVariables();
  }
  const handleUpdateClick = async () => {
    const apiUrl = domain + "/api/OnBoarding/requirement";
    const base64File = file ? await fileToBase64(file) : null;

    const data = {
      onBoardingId: selectedData.id,
      onBoardingRequirementsId: onBoardingRequirements.id,
      file: base64File, // backend must decode this into byte[]
      fileName: file?.name ?? null,
      hasCompleted: hasCompleted,
      isActive: isActive,
    };

        console.log('Final bulkData:', JSON.stringify(data, null, 2));

    try {
        setLoading(true);
        await axios.put(`${apiUrl}/${selectedReq?.id}`, data, {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json'
            }
        });
        
        await fetchData(); // Assuming fetchData() fetches the updated data for the table

        console.log('Data added successfully');
        setShowRequestMessage(true);
        setIsSuccess(true);
    } catch (error) {
        console.error('There was a problem adding data:', error);
        setShowRequestMessage(true);
        setIsSuccess(false);
        const errorMessage = JSON.parse(error.response.request.responseText).message;
        setRequestMessage(errorMessage);
    } finally {
        setLoading(false);
    }
  };

  const addHandleClick = () => {
    openAddForm()
  }

  const editHandleClick = (data) => {
    setSelectedReq(data);

    const reqData = {
      id: data.onBoardingRequirementsId,
      description: data.onBoardingRequirementsDescription
    }

    // ✅ If there's a file from backend, reconstruct it
    if (data.file) {
      const binaryData = atob(data.file); // decode base64

      const arrayBuffer = new ArrayBuffer(binaryData.length);
      const uint8Array = new Uint8Array(arrayBuffer);

      for (let i = 0; i < binaryData.length; i++) {
        uint8Array[i] = binaryData.charCodeAt(i);
      }

      // use mimeType + fileName if you store them in DB
      const mimeType = data.mimeType || "application/octet-stream";
      const fileName = data.fileName;

      const blob = new Blob([uint8Array], { type: mimeType });
      const file = new File([blob], fileName, { type: mimeType });

      setFile(file); // ✅ now your state is a real File object
    } else {
      setFile(null);
    }

    setOnBoardingRequirements(reqData)
    setHasCompleted(data.hasCompleted)
    setIsActive(data.isActive)
    openUpdateForm()
  }

  const downloadHandleClick = async (data) => {
    try {
      setLoading(true); // ✅ start loading

      if (data.file) {
        const binaryData = atob(data.file); // decode base64

        const arrayBuffer = new ArrayBuffer(binaryData.length);
        const uint8Array = new Uint8Array(arrayBuffer);

        for (let i = 0; i < binaryData.length; i++) {
          uint8Array[i] = binaryData.charCodeAt(i);
        }

        // use mimeType + fileName if you store them in DB
        const mimeType = data.mimeType || "application/octet-stream";
        const fileName = data.fileName || "download";

        const blob = new Blob([uint8Array], { type: mimeType });
        const file = new File([blob], fileName, { type: mimeType });

        const url = URL.createObjectURL(file);
        const link = document.createElement("a");
        link.href = url;
        link.download = fileName;
        link.click();

        URL.revokeObjectURL(url);
      } else {
        console.warn("No file data found.");
      }
    } catch (error) {
      console.error("Error downloading file:", error);
    } finally {
      setLoading(false); // ✅ always end loading
    }
  };

  const actions = [
    { 
      name: "Edit", 
      tooltip: "edit",
      icon: <EditIcon fontSize="small" />,
      className: "bg-green-500 hover:bg-green-600 flex items-center",
      function: editHandleClick,
      visible: true,
    },
    { 
      name: "Download", 
      tooltip: "download",
      icon: <DownloadIcon fontSize="small" />,
      className: "bg-sky-500 hover:bg-sky-600 flex items-center",
      function: downloadHandleClick,
      visible: false,
    },
  ];
  // Table /////////////////////////////////////////////

  if (!visible) return null;

  const resetLocalVariables = () => {
    setFailMessage("")
    setSelectedReq(null);
    setEmployee(null);
    setOnBoardingRequirements(null);
    setFile(null);
    setHasCompleted(false);
    setIsActive(false);
  }

  const closeModal = () => {
    onClose();
    resetLocalVariables();
  }

  return (
    <>
      <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center text-gray-600">
        <div className="bg-white rounded-lg shadow-lg w-full max-w-md md:max-w-none md:w-1/2 p-6">
          <h2 className="text-2xl font-semibold mb-4">{modalName}</h2>

          <div className="space-y-5 mt-10 max-h-[500px] overflow-y-auto short:max-h-[300px] medium:h-[400px]">
            <SearchBar handleFilter={handleFilter}/>

            <Button icon={<AddIcon/>} 
              name={"Add"}
              className={"bg-customGreen hover:bg-customGreenHover border-none cursor-pointer"}
              onClick={addHandleClick}
            />

            <CreateTable
              tableName={"OnBoarding"}
              headers={headers}
              accessors={accessors}
              data={requirements ?? []}
              actions={actions}

              currentPage={currentPage}
              setCurrentPage={setCurrentPage}
              itemsPerPage={itemsPerPage}
              totalItems={requirements?.length}
            />
          </div>

          <div className="flex justify-end space-x-2 mt-6">
            <button
              className="px-4 py-2 bg-red-600 text-white rounded-md hover:bg-red-700 transition border-none cursor-pointer"
              onClick={closeModal}
            >
              Cancel
            </button>
          </div>
        </div>
      </div>

      <AddUpdateModal 
        visible={showAddForm}
        onClose={closeAddForm}
        onSave={handleAddClick}
        modalName={"Add Data"}

        data={data}
        employee={employee} setEmployee={setEmployee}
        onBoardingRequirements={onBoardingRequirements} setOnBoardingRequirements={setOnBoardingRequirements}
        file={file} setFile={setFile}
        hasCompleted={hasCompleted} setHasCompleted={setHasCompleted}
        isActive={isActive} setIsActive={setIsActive}
      />

      <AddUpdateModal 
        visible={showUpdateForm}
        onClose={closeUpdateForm}
        onSave={handleUpdateClick}
        modalName={"Update Data"}

        data={data}
        employee={employee} setEmployee={setEmployee}
        onBoardingRequirements={onBoardingRequirements} setOnBoardingRequirements={setOnBoardingRequirements}
        file={file} setFile={setFile}
        hasCompleted={hasCompleted} setHasCompleted={setHasCompleted}
        isActive={isActive} setIsActive={setIsActive}
      />

      <GenerateMessage form={showRequestMessage}
              message={isSuccess ? "Request Success!" : requestMessage}
              isSuccess={isSuccess}
      > 
      </GenerateMessage>

      <FailMessage message={failMessage} onClose={() => setFailMessage("")} />

      {loading ? (
        <div
            style={{
            position: "fixed",
            top: "0",
            left: "0",
            width: "100vw",
            height: "100vh",
            zIndex: "2000",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            textAlign: "center",
            backgroundColor: "#ffffff59",
            }}
        >
            <img src={loadingSpinner} alt="Loading..." />
        </div>
        ) : (
            <></>
            )
        }
    </>
  );
};
const SyncUserModal = ({ visible, onClose, onSave, modalName,
  data,
  selectedData
}) => {
  const [showChangeInfoConfirmationForm, setShowChangeInfoConfirmationForm] = useState(false);
  const openChangeInfoConfirmationForm = () => {
    setShowChangeInfoConfirmationForm(true)
  }
  const closeChangeInfoConfirmationForm = () => {
    setShowChangeInfoConfirmationForm(false)
  }
  if (!visible) return null;

  const handleSubmit = async () => {
    await onSave();
    closeModal();
  };

  const resetLocalVariables = () => {
  }

  const closeModal = () => {
    onClose();
    resetLocalVariables();
  }

  return (
    <>
      <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center text-gray-600">
        <div className="bg-white rounded-lg shadow-lg w-full max-w-md p-6">
          <h2 className="text-2xl font-semibold mb-4">{modalName}</h2>

          <div className="space-y-5 mt-10 max-h-[500px] overflow-y-auto short:max-h-[300px] medium:h-[400px]">
            <span>
              {`Are you sure you want to sync this to your employee list as Employee ID: ${selectedData?.onBoardingPersonnelEmployeeId} - ${selectedData?.onBoardingPersonnelFullName}?`}
            </span>
          </div>

          <div className="flex justify-end space-x-2 mt-6">
            <button
              className="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 transition border-none cursor-pointer"
              onClick={handleSubmit}
            >
              Proceed
            </button>
            <button
              className="px-4 py-2 bg-red-600 text-white rounded-md hover:bg-red-700 transition border-none cursor-pointer"
              onClick={closeModal}
            >
              Cancel
            </button>
            <button
              className="px-4 py-2 bg-green-600 text-white rounded-md hover:bg-green-700 transition border-none cursor-pointer"
              onClick={openChangeInfoConfirmationForm}
            >
              Change Info
            </button>
          </div>
        </div>
      </div>

      { showChangeInfoConfirmationForm && <ChangeInformationConfirmationModal 
        visible={showChangeInfoConfirmationForm}
        onClose={closeChangeInfoConfirmationForm}
        modalName={`Change Information Confirmation`}
      />}
    </>
  );
};
const ChangeInformationConfirmationModal = ({ visible, onClose, onSave, modalName,
}) => {
  if (!visible) return null;

  const resetLocalVariables = () => {
  }

  const closeModal = () => {
    onClose();
    resetLocalVariables();
  }

  const changeInfoHandleClick = () => {
    window.location.pathname = '/onBoardingPersonnel'
  }

  return (
    <>
      <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center text-gray-600">
        <div className="bg-white rounded-lg shadow-lg w-full max-w-md p-6">
          <h2 className="text-2xl font-semibold mb-4">{modalName}</h2>

          <div className="space-y-5 mt-10 max-h-[500px] overflow-y-auto short:max-h-[300px] medium:h-[400px]">
            <span>
              {`To edit this information, you will be redirected to the On Boarding Personnel page. Do you want to proceed?`}
            </span>
          </div>

          <div className="flex justify-end space-x-2 mt-6">
            <button
              className="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 transition border-none cursor-pointer"
              onClick={changeInfoHandleClick}
            >
              Proceed
            </button>
            <button
              className="px-4 py-2 bg-red-600 text-white rounded-md hover:bg-red-700 transition border-none cursor-pointer"
              onClick={closeModal}
            >
              Cancel
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default OnBoarding
